import axios from "axios";
import WriteToLog from "./WriteToLog";
import getObservationFlowsheetWithin7Days from "./getObservationFlowsheetWithin7Days";

/**
 * Get Respiratory Device Flowsheet Row value from EHR
 * @param {*} patFHIRID 
 * @param {*} encodedFloID 
 * @param {*} codeText 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationRespDeviceFlowsheet(patFHIRID, encodedFloID, codeText, fhir_server, access_token) {
  const floObj = {};
  let floValue = "";

  var date = new Date();
  date.setHours(date.getHours() - 168);
  //console.log("date - 168 hours (7 days): " + date);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';
  //console.log(isoStringWithoutMs);

  const ehrconfig = await axios.get('ehrconfig.json');
  let config = ehrconfig.data[fhir_server];
  //const EHR_RESPIRATORY_DEVICE_VALUE = ehrconfig.data["EHR_RESPIRATORY_DEVICE_VALUE"];
  const EHR_HNFC_VALUE = ehrconfig.data["EHR_HNFC_VALUE"];
  let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
  let getObservationFlowsheetUrl = fhir_server + observationSearchUrl + '?code=' + encodedFloID + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs;

  try {
    let response = await axios.get(
      getObservationFlowsheetUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    //console.log("getObservationRespDeviceFlowsheet Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      // Get the latest value from the top entryArray[0]
      if (entryArray.length > 0) {
        if (entryArray[0].resource !== undefined) {
          let resourceType = entryArray[0].resource.resourceType;
          //console.log("Resource Type: " + resourceType);
          if (resourceType === "Observation" && entryArray[0].resource.code !== undefined) {
            //let code = entryArray[0].resource.code.text;
            //console.log("Code: " + code);
            //console.log("issued: " + entryArray[0].resource.issued);
            if (entryArray[0].resource.valueQuantity !== undefined) {
              floValue = entryArray[0].resource.valueQuantity.value + "" + entryArray[0].resource.valueQuantity.unit;
            }
            if (entryArray[0].resource.valueCodeableConcept !== undefined) {
              floValue = entryArray[0].resource.valueCodeableConcept.text;
            }
          }
        }
      }
      floObj[codeText] = floValue;
      /* Moved to RiskAssessment.js.. Check if Respiratory Device is set to Ventilation Non-Invasive value. If set, get PIP/iPAP Actual, PIP/iPAP Set, FiO2, PEEP/CPAP Actual, PEEP/CPAP Set value  */
      //if (floValue.includes(EHR_RESPIRATORY_DEVICE_VALUE)) { 
        /* Call FiO2, BiPAP and CPAP flowsheet calls here */
        const promisesArray = [getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_BiPAP_ACTUAL_FLOWSHEET, "PIP/iPAP Actual", fhir_server, access_token),
                               getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_BiPAP_SET_FLOWSHEET, "PIP/iPAP Set", fhir_server, access_token),
                               getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_FIO2_FLOWSHEET, "FiO2", fhir_server, access_token),
                               getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_CPAP_ACTUAL_FLOWSHEET, "PEEP/CPAP Actual", fhir_server, access_token),
                               getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_CPAP_SET_FLOWSHEET, "PEEP/CPAP Set", fhir_server, access_token)];
  
        const results = await Promise.allSettled(promisesArray);
        // results is an array of:
        // {status: "fulfilled", value: {PIP/iPAP Actual: {timestamp: '2025-03-22T02:25:01Z', unit: 'cm H2O', value: 27}}} // FLO ID 40000699 - PIP/iPAP Actual (cmH2O)
        // {status: "fulfilled", value: {PIP/iPAP Set: '27cm H2O'}} // FLO ID 40010946 - PIP/iPAP Set (cmH2O)
        // {status: "fulfilled", value: {FiO2: '55%'}} // FLO ID 40002468 - FiO2 (%)
        // {status: "fulfilled", value: {PEEP/CPAP Actual: '8cm H2O'}} // FLO ID 40010947 - PEEP/CPAP Actual  (cmH2O)
        // {status: "fulfilled", value: {PEEP/CPAP Set: '8cm H2O'}} // FLO ID 40000566 - PEEP/CPAP Set  (cmH2O)
        //console.log(results);
  
        for (let i=0; i < results.length; i++) {
          if (results[i].status === "fulfilled" && (results[i].value !== "Resource request returns no results." || results[i].value !== undefined)) {
            if(results[i].value) {
              if (results[i].value["PIP/iPAP Actual"]) {
                floObj.BiPAP = results[i].value["PIP/iPAP Actual"];
              }
              if (results[i].value["PIP/iPAP Set"]) {
                floObj.BiPAPSet = results[i].value["PIP/iPAP Set"];
              }
              if (results[i].value["FiO2"]) {
                floObj.FiO2 = results[i].value["FiO2"];
              }
              if (results[i].value["PEEP/CPAP Actual"]) {
                floObj.CPAP = results[i].value["PEEP/CPAP Actual"];
              }
              if (results[i].value["PEEP/CPAP Set"]) {
                floObj.CPAPSet = results[i].value["PEEP/CPAP Set"];
              }
            }
          }
        }
      //}
      /* Check if Respiratory Device is set to High flow nasal cannula. If set, pull data from Flowsheet ID 40000234 (rate) */
      if (floValue.includes(EHR_HNFC_VALUE)) {
        // Get the Flow Rate value from Epic
        const promisesArr = [getObservationFlowsheetWithin7Days(patFHIRID, config.EHR_FLOW_RATE_FLOWSHEET, "Flow Rate", fhir_server, access_token)];
        const floRateResult = await Promise.allSettled(promisesArr);
        console.log(floRateResult);
        for (let i=0; i < floRateResult.length; i++) {
          if (floRateResult[i].status === "fulfilled" && (floRateResult[i].value !== "Resource request returns no results." || floRateResult[i].value !== undefined)) {
            if(floRateResult[i].value) {
              if (floRateResult[i].value["Flow Rate"]) {
                floObj.FlowRate = floRateResult[i].value["Flow Rate"];
              }
            }
          }
        }
      }

      WriteToLog("getObservationRespDeviceFlowsheet Observation.Search (R4) response for " +  JSON.stringify(floObj));
      return floObj;
    } else {
      //ehr value empty if total is 0
      let entryArray = response.data.entry;
      for (var j = 0; j < entryArray.length; j++) {
        if (entryArray[j].resource !== undefined) {
          let resourceType = entryArray[j].resource.resourceType;
          if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
            let issueArray = entryArray[j].resource.issue;
            if (issueArray.length > 0) {
              if (entryArray[j].resource.issue[0].diagnostics !== undefined)
              {
                floValue = "Error: " + entryArray[j].resource.issue[0].diagnostics;
              } else {
                floValue = entryArray[j].resource.issue[0].details.text;
              }
            }
          }
        }
      }
      return floValue;
    }
  } catch (error) {
    if (!error.message.includes("401")) { // 401 - Access Token Expired
      WriteToLog("getObservationRespDeviceFlowsheet Observation.Search FHIR error: " + error.message);
    }
    return null; 
  }
}

export default getObservationRespDeviceFlowsheet;
